export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.0da74bbc.worker.js");
}
